import { CommonModule } from '@angular/common';
import { Component, QueryList, ViewChildren } from '@angular/core';
import { SrStatus } from '../../../../shared/constants/status.enum';
import { ReactiveFormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ApiService } from '../../../../core/services/api.service';
import { FileComponent } from '../../../../shared/components/controls/file/file.component';
import { SkeletonLoaderComponent } from '../../../../shared/components/skeleton-loader/skeleton-loader.component';
import { SrSubmitSuccessModalComponent } from '../../../../shared/components/sr-submit-success-modal/sr-submit-success-modal.component';
import { ApiRoot, ApiEndPoints } from '../../../../shared/constants/api-endpoints';
import { LookupKey } from '../../../../shared/constants/lookup-keys';
import { RoutesPath } from '../../../../shared/constants/routes-path';
import { DocumentServiceType, ServiceName, SrActionType, FieldValue } from '../../../../shared/constants/services.enum';
import { FolderResponse, AllowedDocumentType } from '../../../../shared/models/documents-response.model';
import { SharedService } from '../../../../shared/services/shared.service';
import { SHARED_COMPONENTS } from '../../../../shared/shared-imports';
import { Utils } from '../../../../Utils/utils';
import { customValidator } from '../../../../Utils/validator';
import { MRMAwardCreateUpdateRequest } from './models/mrm-award-create-update.model';
import { ApplicationRequest } from '../../../../shared/models/application-request.model';
import { PendingSrModalComponent } from "../../../../shared/components/pending-sr-modal/pending-sr-modal.component";
@Component({
  selector: 'app-mrm-awards-training-workshop',
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, ...SHARED_COMPONENTS, SrSubmitSuccessModalComponent, SkeletonLoaderComponent, PendingSrModalComponent],
  templateUrl: './mrm-awards-training-workshop.component.html',
  styleUrl: './mrm-awards-training-workshop.component.scss'
})
export class MrmAwardsTrainingWorkshopComponent {
  @ViewChildren('fileCmp') fileComponents!: QueryList<FileComponent>;
  applicationRequestPayload: ApplicationRequest = new ApplicationRequest();
  servicePath: 'mrm-award' | 'training-workshop' = 'mrm-award';
  documentServiceType = DocumentServiceType;
  form: FormGroup;
  lookupKey = LookupKey;
  step = 1;
  totalSteps = 3;
  isSaved = false;
  showActions: boolean = true;
  lang: string = 'en';
  loginUserDetail: any;
  userLoginName: string = '';
  userCSN: string = '';
  selectedMember: any;
  successModal: boolean = false;
  srNumber: string = "";
  srDetailLoader: boolean = false;

  constructor(
    private fb: FormBuilder,
    private sharedService: SharedService,
    private api: ApiService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.lang = this.sharedService.getCurrentLang();
    this.loginUserDetail = this.sharedService.getUserProfile();
    this.userLoginName = this.sharedService.getUserProfile()['Login Name'];
    this.userCSN = this.sharedService.getCsnAccountId('csn');
    this.selectedMember = this.sharedService.getPrimaryAccount();

    this.route.data.subscribe(data => {
      this.servicePath = data['mode'];
    });
    this.form = this.buildForm();
    const routeSrNumber = this.route.snapshot.params?.['sr_no'];
    if (routeSrNumber) {
      this.srNumber = routeSrNumber;
    }

    this.sharedService.getSrNumber(this.route).subscribe(srNumber => {
      if (srNumber && srNumber !== this.srNumber) {
        this.srDetailLoader = true;
        this.srNumber = srNumber;
        this.getSRDetail();
        this.step = 1;
      }
    });
    // in case of draft
    if (sessionStorage.getItem("srNumber") && this.srNumber == "") {
      let storeSrNumber: any = sessionStorage.getItem("srNumber");
      this.srNumber = storeSrNumber;
    }

    if (!this.userCSN && !this.srNumber) {
      this.sharedService.toastMessage('INFO', 'NO_CSN_NUMBER', 'info');
      this.router.navigate([RoutesPath.DASHBOARD]);
      return;
    }
    // this.getApplications();
    // this.checkForPendingSr();

    //check if mrm application exist for current year
    if (this.srNumber) {
      this.srDetailLoader = true;
      this.getSRDetail();
      this.step = 1;
    } else {
      const dcHiStartDate = this.selectedMember?.['DC HI Start Date'];
      const dcHiEndDate = this.selectedMember?.['DC HI End Date'];
      // if (!dcHiStartDate) {
      //   this.router.navigate([RoutesPath.DASHBOARD]);
      //   return;
      // }
      if (dcHiEndDate) {
        const endDate = new Date(dcHiEndDate);
        const currentYear = new Date().getFullYear();

        if (endDate.getFullYear() === currentYear) {
          this.sharedService.toastMessage(
            'INFO',
            'MRM_AWARDS_ALREADY_CREATED',
            'info',
            true
          );
          this.router.navigate([RoutesPath.DASHBOARD]);
          return;
        }
      }

      // this.getTraineeFees(); //For mrm Training workshop
      this.setDefaults();
      this.openFolder();
    }
  }

  private buildForm(): FormGroup {
    return this.fb.group({
      membershipNumber: [{ value: '', disabled: true }, [Validators.required]],
      memberNameAr: [{ value: '', disabled: true }, [Validators.required]],
      memberNameEn: [{ value: '', disabled: true }, [Validators.required]],
      paymentMethod: ['', [Validators.required]],
      unitPrice: [{ value: 0, disabled: true }, [customValidator('numberWithDecimal')]],
      delegates: [null],
    });
  }

  get isTrainingWorkshop() {
    return this.servicePath == 'training-workshop' ? true : false;
  }

  pendingSrNumber: string = "";
  pendingSrDetail: any = "";
  // This method is used to check for pending sr
  // checkForPendingSr() {
  //   if (this.srNumber == "" && !this.isTrainingWorkshop) {
  //     this.srDetailLoader = true;
  //     this.sharedService.checkInprogressApplication(this.userCSN, ServiceName.MRM_AWARDS, ServiceName.MRM_APPLICATION)
  //       .subscribe({
  //         next: (response: any) => {
  //           if (response["Error Code"] == null && response["Error Message"] == null && response?.SiebelMessage['DC Community Portal SR']) {
  //             let srData = response?.SiebelMessage['DC Community Portal SR'];
  //             if (srData['SR Number']) {
  //               this.pendingSrNumber = srData['SR Number'];
  //               this.pendingSrDetail = srData;
  //               return;
  //             }
  //           } else {
  //             this.srDetailLoader = false;
  //             if (this.srNumber == "" || !this.srNumber) {

  //             }
  //           }
  //         }
  //       })
  //   } else {
  //     if (this.userCSN && this.srNumber) {

  //     }
  //   }

  //   this.getApplications();
  // }

  MRMApplications: any = [];
  eligibleApplications: any = [];

  getApplications() {
    this.srDetailLoader = true;
    const currentYear = new Date().getFullYear();
    const allowedStatuses = [SrStatus.Paid, SrStatus.Closed];
    let userLoginName = this.sharedService.getUserProfile()['Login Name'];
    this.applicationRequestPayload.body.IncomingHierarchy.MessageId = Utils.generateUniqueId();

    this.applicationRequestPayload.body.IncomingHierarchy.ListOfDCGetSRSummaryIO["Service Request"]["Account Id"] = '';
    this.applicationRequestPayload.body.IncomingHierarchy.ListOfDCGetSRSummaryIO["Service Request"].CSN = this.userCSN;
    this.applicationRequestPayload.body.IncomingHierarchy.ListOfDCGetSRSummaryIO["Service Request"]["SR Number"] = '';
    this.applicationRequestPayload.body.IncomingHierarchy.ListOfDCGetSRSummaryIO["Service Request"]["SR Type"] = ServiceName.MRM_AWARDS;
    this.applicationRequestPayload.body.IncomingHierarchy.ListOfDCGetSRSummaryIO["Service Request"]["SR Sub Type"] = ServiceName.MRM_APPLICATION;
    this.applicationRequestPayload.body.IncomingHierarchy.ListOfDCGetSRSummaryIO["Service Request"]["Status"] = "";
    this.applicationRequestPayload.body.IncomingHierarchy.ListOfDCGetSRSummaryIO["Service Request"]['Created By Name'] = "";
    this.applicationRequestPayload.body.PageSize = 50;
    this.applicationRequestPayload.body.StartRowNum = 0;
    this.applicationRequestPayload.body.NewQuery = true;
    this.applicationRequestPayload.body.NoDays = 365;
    this.api.post(ApiRoot.DCCICPIntegration, ApiEndPoints.GET_SR_SUMMARY, this.applicationRequestPayload)
      .subscribe({
        next: (response: any) => {
          if (response?.SiebelMessage) {
            if (response?.SiebelMessage['Service Request']) {
              this.MRMApplications = Utils.checkIsArray(response?.SiebelMessage['Service Request']);
              this.eligibleApplications = (this.MRMApplications || []).filter((application: any) => {
                const status = application?.Status ?? application?.['Status'];
                const createdValue = application?.['DC Created'];
                const createdDate = createdValue ? new Date(createdValue) : null;
                const isCurrentYear = createdDate instanceof Date && !isNaN(createdDate.getTime())
                  ? createdDate.getFullYear() === currentYear
                  : false;
                return isCurrentYear && allowedStatuses.includes(status);
              });

              if (this.isTrainingWorkshop && this.eligibleApplications.length < 1) {
                if (!this.srNumber) {
                  this.sharedService.toastMessage('INFO', 'MRM_AWARDS_NOT_CREATED', 'info', true);
                  this.srDetailLoader = false;
                  this.router.navigate([RoutesPath.DASHBOARD]);
                  return;
                }
                this.srDetailLoader = false;
                return;
              }

              if (!this.isTrainingWorkshop && this.eligibleApplications.length > 0) {
                if (!this.srNumber) {
                  this.sharedService.toastMessage('INFO', 'MRM_AWARDS_ALREADY_CREATED', 'info', true);
                  this.srDetailLoader = false;
                  this.router.navigate([RoutesPath.DASHBOARD]);
                  return;
                }
                this.srDetailLoader = false;
                return;
              }

              this.srDetailLoader = false;
            } else {
              if (this.isTrainingWorkshop) {
                if (!this.srNumber) {
                  this.sharedService.toastMessage('INFO', 'MRM_AWARDS_NOT_CREATED', 'info', true);
                  this.srDetailLoader = false;
                  this.router.navigate([RoutesPath.DASHBOARD]);
                  return;
                }
                this.srDetailLoader = false;
                return;
              }
              this.srDetailLoader = false;
            }
          }
        }
      })
  }

  mrmFeesList: any = [];
  private getTraineeFees(): void {
    //Fill unit price based on as : Name== "MRMTRANINGFEES_"+sMemtype+"_"+No_Of_Delegates
    let request = {
      body: {
        ProcessName: "DC Get List Of Values WF",
        Type: LookupKey.DC_MRM_FEES, //NUMBER_OF_YEARS
        "LanguageCode": this.sharedService.getCurrentLang() == "ar" ? 'ARA' : "ENU",
        ParentValue: "",
        "Sub Type": ""
      }
    }
    this.api
      .post(ApiRoot.DCCICPIntegration, LookupKey.LOOKUP_URL, request)
      .subscribe({
        next: (result: any) => {
          if (result.SiebelMessage?.['List Of Values'] && result["Error Message"] == null || result["Error Message"] == "") {
            this.mrmFeesList = Utils.checkIsArray(result.SiebelMessage['List Of Values']);
          }
        }
      })
  }

  getUnitPrice(option: any) {
    const delegatesCount = option?.selectedLov?.Value ?? option;
    const accountType = this.sharedService.getPrimaryAccount()['Account Type Code'];
    if (!delegatesCount || !accountType) {
      this.form.get('unitPrice')?.setValue(0);
      return;
    }
    const lookupName = `MRMTRANINGFEES_${accountType}_${delegatesCount}`;
    const matchedFee = (this.mrmFeesList || []).find((fee: any) => fee?.Name === lookupName);
    const unitPrice = matchedFee?.Value ? Number(matchedFee.Value) : 0;

    this.form.get('unitPrice')?.setValue(unitPrice);
  }
  private setDefaults(): void {
    const patch: any = {};
    this.form.patchValue({
      membershipNumber: this.userCSN,
      memberNameAr: this.selectedMember['DC Name Arabic'],
      memberNameEn: this.selectedMember['DC Name English'],
      ...patch
    });
    this.toggleRequired(this.isTrainingWorkshop, ['delegates', 'unitPrice']);
  }
  // This method is used to toggle required using condition and controls
  private toggleRequired(condition: boolean, controls: string[]): void {
    Utils.addRemoveValidation(this.form, condition, controls);
  }

  // This method is used to move to the next step
  nextStep(): void {
    let fields = [
      'membershipNumber',
      'memberNameAr',
      'memberNameEn',
      'delegates',
      'unitPrice'
    ]
    const stepOneFields =
      this.step === 1
        ? fields
        : [];

    const stepThreeFields =
      this.step === 3
        ? ['paymentMethod']
        : [];

    if (
      stepOneFields.length > 0 &&
      stepOneFields.some((f) => this.form.get(f)?.invalid)
    ) {
      stepOneFields.forEach((f) => this.form.get(f)?.markAsTouched());
      return;
    }

    if (
      stepThreeFields.length > 0 &&
      stepThreeFields.some((f) => this.form.get(f)?.invalid)
    ) {
      stepThreeFields.forEach((f) => this.form.get(f)?.markAsTouched());
      const invalidControls = Utils.getInvalidControls(this.form);
      this.form.markAllAsTouched();
      this.sharedService.toastMessage('ERROR', "FILL_REQUIRED_FIELDS_DOCUMENTS", 'error', false);
      return;
    }
    if (this.step <= 2) {
      if (!this.srNumber) {
        this.loadingDoc = true;
      }
      this.submitSRData(this.form.getRawValue(), SrActionType.DRAFT);
    }
    if (this.step >= 3) {
      this.submitSRData(this.form.getRawValue(), SrActionType.SUBMIT);
    }
    if (this.step < 3) {
      this.step++;
    }
  }

  srInprgoressAwating: boolean = false;
  showNotes: boolean = false;
  // This method is used to get sr detail
  getSRDetail() {
    if (!this.srNumber) {
      return;
    }
    this.noAdvancePaymentBalance = false;
    let queryReq = {
      "body": {
        "ProcessName": "DC Create Update MRM SR WF",
        "DC Method": "QUERY",
        "SR Number": this.srNumber,
        "DC Channel": this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN
      }
    }
    this.api.post(
      ApiRoot.DCCICPIntegration,
      ApiEndPoints.RUN_PROCESS,
      queryReq
    ).subscribe({
      next: (response: any) => {
        if (response["Error Code"] == "") {
          let serviceRequest = response;
          this.userCSN = serviceRequest['Member Number'] || this.userCSN;
          this.srDetailLoader = false;
          this.form.patchValue({
            membershipNumber: serviceRequest['Member Number'],
            memberNameEn: serviceRequest['Member Name English'],
            memberNameAr: serviceRequest['Member Name Arabic'],
            paymentMethod: serviceRequest['DC Payment Method'],
            unitPrice: serviceRequest['Unit Price'],
            delegates: serviceRequest['Deligates Number']
          });

          if (this.sharedService.enableNotesOption(serviceRequest["Status"])) {
            this.srInprgoressAwating = true;
            this.showNotes = true;
          }
          if (serviceRequest["Status"] != SrStatus.Draft && serviceRequest["Status"] != SrStatus.AwaitingClarification) {
            this.showActions = false;
            this.form.disable(); // disables all fields in the form
          }
          this.step = 3;
          this.openFolder();
          this.srDetailLoader = false;
        } else {
          this.srDetailLoader = false;
          if (response['Error Code'] && response["Error Message"] != null) {
            // this.errorMsg = response['Error Message'];
            this.technicalErrorMsg = true;
          } else {
          }
        }
      }
    })

  }
  // This method is used to save and close
  saveAndClose(): void {
    this.submitSRData(this.form.getRawValue(), SrActionType.SAVE);
  }

  errorMsg: any = "";
  formSubmitLoader: boolean = false;
  technicalErrorMsg: boolean = false;
  submitSRData(formData: any, actionType: string) {
    this.errorMsg = "";
    let isActionSubmit = actionType == SrActionType.SUBMIT;
    let isActionSave = actionType == SrActionType.SAVE;
    let isActionDraft = actionType == SrActionType.DRAFT;
    const defaultShowActions = this.showActions;
    const restoreFormState = () => {
      this.showActions = defaultShowActions;
      this.form.enable({ emitEvent: false });
      this.form.get('membershipNumber')?.disable({ emitEvent: false });
      this.form.get('memberNameAr')?.disable({ emitEvent: false });
      this.form.get('memberNameEn')?.disable({ emitEvent: false });
      this.form.get('unitPrice')?.disable({ emitEvent: false });
      this.formSubmitLoader = false;
    };

    let SrSubType = this.isTrainingWorkshop ? ServiceName.MRM_TRAINING_WORKSHOP : ServiceName.MRM_APPLICATION;
    const requestPayload = new MRMAwardCreateUpdateRequest();

    // requestPayload.body.DCLoginName = this.userLoginName;
    // requestPayload.body.DCIncomingHierarchy.MessageId = Utils.generateUniqueId();
    requestPayload.body['DC Method'] = isActionSubmit ? 'SUBMIT' : 'SAVEASDRAFT';
    requestPayload.body['SR Number'] = this.srNumber;
    requestPayload.body["DC Channel"] = this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN;
    requestPayload.body["DC Payment Method"] = formData.paymentMethod ? formData.paymentMethod : "";
    requestPayload.body['SR Type'] = ServiceName.MRM_AWARDS;
    requestPayload.body['SR Sub Type'] = SrSubType;
    requestPayload.body['Unit Price'] = formData.unitPrice ? formData.unitPrice : "";
    requestPayload.body['Member Name English'] = formData.memberNameEn ? formData.memberNameEn : "";
    requestPayload.body['Member Name Arabic'] = formData.memberNameAr ? formData.memberNameAr : "";
    requestPayload.body['Member Number'] = this.userCSN;
    requestPayload.body['Deligates Number'] = formData.delegates ? formData.delegates : "";
    requestPayload.body['Language'] = this.lang == 'ar' ? 'ARA' : 'ENU';


    if (isActionSubmit) {
      if (this.checkRequiredDocuments() || this.noAdvancePaymentBalance || this.loadingDoc) {
        this.sharedService.toastMessage('ERROR', "FILL_REQUIRED_FIELDS_DOCUMENTS", 'error', false);
        return;
      }
    }

    // MRM Award Application
    if (!this.isTrainingWorkshop && this.eligibleApplications && this.eligibleApplications.length > 0) {
      if (this.srNumber != "") {
        this.sharedService.toastMessage('INFO', 'MRM_AWARDS_ALREADY_CREATED', 'info', true);
        this.router.navigate([RoutesPath.DASHBOARD]);
        return;
      }
    }

    if (!isActionDraft) {
      this.showActions = false;
      this.form.disable({ emitEvent: false });
      this.formSubmitLoader = true;
    }
    this.technicalErrorMsg = false;
    this.api.post(
      ApiRoot.DCCICPIntegration,
      ApiEndPoints.RUN_PROCESS,
      requestPayload
    ).subscribe({
      next: (response: any) => {
        if ((response['Error Code'] == "" || response['Error Code'] == "DC-VAL-ERR")
          && response["Error Message"] == null || response["Error Message"] == ""
          && response["SR Number"]) {
          this.isSaved = true;
          if (isActionSave || isActionDraft) {
            if (isActionDraft && this.srNumber == "") {
              this.srNumber = response["SR Number"];
              sessionStorage.setItem("srNumber", response["SR Number"]);
              this.openFolder();
            } else {
              this.srNumber = response["SR Number"];
              if (isActionSave) {
                this.successModal = true;
              }
            }
          } else {
            this.srNumber = response["SR Number"];
            let lang: any = this.sharedService.getCurrentLang();

            const { service, serviceAr } = Utils.getServiceLabels(SrSubType, lang);
            let srDetailObj = {
              serviceSubTypeEn: service,
              serviceSubTypeAr: serviceAr,
              service: ServiceName.MRM_AWARDS,
              IOName: '',
              srNumber: this.srNumber,
              totalSteps: this.totalSteps,
              step: this.step + 1
            }
            this.sharedService.setSrResponse(srDetailObj);
            sessionStorage.removeItem("srNumber");
            this.sharedService.toastMessage('SUCCESS', 'REQUEST_SUBMITTED', 'success');
            if (response['Status'] == SrStatus.ApprovedAndPaymentAwaited &&
              (formData.paymentMethod == FieldValue.PAYMENT_METHOD_ONLINE_EN ||
                formData.paymentMethod == FieldValue.PAYMENT_METHOD_ONLINE_AR)) {
              this.router.navigate([`${RoutesPath.SERVICE}/${RoutesPath.PAYMENT}/${response["SR Number"]}`]);

            } else {
              this.router.navigate([`${RoutesPath.SERVICE}/${RoutesPath.SUCCESS_PAGE + "/" + this.srNumber}`]);
            }
          }
          restoreFormState();
        } else {
          restoreFormState();
          if (response['Error Code'] == 'DC-VAL-ERR' && response["Error Message"] != "") {
            this.errorMsg = response['Error Message'];
          } else {
            this.technicalErrorMsg = true;
          }
        }
      },
      error: () => {
        restoreFormState();
        this.technicalErrorMsg = true;
      }
    });
  }

  get formProgress() {
    if (this.form.disabled) {
      return 100;
    }
    if (!this.form.invalid) {
      if (!this.checkRequiredDocuments()) {
        return 100;
      }
    }
    return Utils.calculateFormProgress(this.step, this.totalSteps)
  }
  // This method is used to close success modal
  closeSuccessModal() {
    this.successModal = false;
    sessionStorage.removeItem("srNumber");
    this.router.navigate([RoutesPath.DASHBOARD]);
  }

  srFolder!: FolderResponse;
  mainFromSectionDocs: AllowedDocumentType[] = [];
  visibleDocumentTypes: AllowedDocumentType[] = [];
  loadingDoc: boolean = false
  // This method is used to open folder
  openFolder() {
    this.loadingDoc = true;
    let isLabels = !this.srNumber; // true if srNumber is empty
    this.sharedService.getDocuments(this.srNumber, DocumentServiceType.PS, isLabels)
      .subscribe({
        next: (response: any) => {
          if (response.success) {
            this.loadingDoc = false;
            this.srFolder = response.data ? response.data : response;
          } else {
            this.loadingDoc = false;
            this.sharedService.toastMessage("error", response.message, 'error');
          }
        },
        error: err => {
          this.loadingDoc = false;
          this.sharedService.toastMessage("error", err, 'error');
        }
      });
  }

  // This method is used to handle payment method change event using option
  noAdvancePaymentBalance: boolean = false;
  onPaymentMethodChange(value: any) {
    this.noAdvancePaymentBalance = false;
    const selectedValue = value;
    if (selectedValue === FieldValue.PAYMENT_METHOD_ADVANCE_FOR_SERVICES || selectedValue === FieldValue.PAYMENT_METHOD_ADVANCE_FOR_SERVICES_AR) {
      this.noAdvancePaymentBalance = !this.sharedService.hasSufficientAdvanceForServicesBalance();
    } else {
      this.noAdvancePaymentBalance = false;
    }
  }

  // This method is used to check required documents
  checkRequiredDocuments(): boolean {
    if (!this.mainFromSectionDocs || this.mainFromSectionDocs.length === 0) {
      return false;
    }
    const fileCmps = this.fileComponents && typeof this.fileComponents.toArray === 'function'
      ? this.fileComponents.toArray()
      : [];
    // ViewChildren not ready or not fully rendered yet – defer document checks
    if (fileCmps.length < this.mainFromSectionDocs.length) {
      return false;
    }
    let hasMissing = false;
    for (let index = 0; index < this.mainFromSectionDocs.length; index++) {
      const doc = this.mainFromSectionDocs[index];
      const cmp = fileCmps[index];
      if (!cmp) continue;

      if (typeof cmp.checkMissing === 'function' && cmp.checkMissing((doc)?.mandatory)) {
        hasMissing = true;
      }
    }
    return hasMissing;
  }

  canDeactivate(): boolean {
    return this.sharedService.confirmNavigationIfFormDirty(this.form, this.isSaved);
  }

  // This method is used to close pending sr modal
  closependingSrModal() {
    this.pendingSrNumber = "";
    this.router.navigate([RoutesPath.DASHBOARD]);
  }

  ngOnDestroy(): void {
    sessionStorage.removeItem("srNumber");
  }
}
